import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ButtonModule } from "../button/button.module";
import { TagListComponent } from "./tag-list.component";
import { TagComponent } from "./tag.component";

@NgModule({
  imports: [CommonModule, ButtonModule],
  declarations: [TagListComponent, TagComponent],
  exports: [TagListComponent, TagComponent]
})
export class TagListModule {}
